<template>
    <b-container>
        <Spinner size="32" message="Loading..." v-if="isLoading"> </Spinner>
        <b-alert :show = "showDismissibleAlert" dismissible 
            @dismissed="showDismissibleAlert=false"
            :variant="variant">
            {{alertText}}
        </b-alert>
        <b-form @submit="onSubmit" @reset="onReset" v-if="show">
            <b-row class="justify-content-md-center">
                <b-col md="7" sm="12" class="mt-2">
                    <p style="font-size: 17px;color:#2284ab;">Add Family Details</p>
                    <p></p>
                    <div style="padding: 10px;
                            border: 2px solid #c4c6be;
                            border-radius: 15px;">
                    <b-form-group id="exampleInputGroup1" horizontal
                            label="Full Name <span style='color:red'>*</span>" label-size="sm"
                            label-for="exampleInput1">
                            <b-form-input type="text" placeholder="Family Member Name" size="sm"
                               :formatter="format"  lazy-formatter required v-model="form.UserFamily.FullName"></b-form-input>
                    </b-form-group>
                    <b-form-group id="exampleInputGroup2" horizontal
                            label="Gender <span style='color:red'>*</span>" label-size="sm"
                            label-for="exampleInput2">
                        <b-form-radio-group id="radiosn1" v-model="form.UserFamily.Gender" name="radioNomineeGender">
                            <b-form-radio value="1">Male</b-form-radio>
                            <b-form-radio value="0">Female</b-form-radio>
                        </b-form-radio-group>    
                    </b-form-group>
                    <b-form-group id="exampleInputGroup3" horizontal
                            label="Birth Date <span style='color:red'>*</span>" label-size="sm"
                            label-for="exampleInput3">
                        <!-- <b-form-input id="exampleInput2"
                            type="date"
                            v-model="form.UserFamily.DOB"
                            required size="sm"
                            placeholder="Date of Birth"></b-form-input>    -->
                        <date-picker v-model="DOB" :not-after="currentDate" format="DD-MM-YYYY" lang="en" required size="small"></date-picker>
                    </b-form-group>
                    <b-form-group id="exampleInputGroup2" horizontal  label-size="sm"
                            label="Relationship <span style='color:red'>*</span>" required
                            label-for="exampleInput2">
                        <b-form-select id="exampleInput1"
                                :options="relations"
                                required size="sm"
                                value-field="RelationshipID"
                                text-field="RelationshipName"
                                v-model="form.UserFamily.ReletionShipID">
                        </b-form-select>    
                    </b-form-group>
                  
                    </div>
                </b-col>

            </b-row>
            
            <b-row class="mt-2 justify-content-md-center" v-if="!LockProfile">
                <b-col md="4" sm="12" style="text-align:center">
                  <Spinner size="32" message="Loading..." v-if="isLoading"> </Spinner>
                  <b-alert :show = "showDismissibleAlert" dismissible 
                      @dismissed="showDismissibleAlert=false"
                      
                      :variant="variant">
                      {{alertText}}
                  </b-alert>
                </b-col>
                <b-col  md="4" sm="12" style="text-align:right" >
                  <b-button type="submit" variant="primary">Add to List</b-button>
                  <b-button type="reset" variant="danger">Reset</b-button>
                  <b-button variant="secondary" @click="onClickButton" v-if="saved">Next</b-button>
                </b-col>
            </b-row>
        </b-form>
        <div style="padding: 10px;
                            border: 2px solid #c4c6be;
                            border-radius: 15px;"  class="mt-2">
                <p style="font-size: 17px;color:#2284ab;">Family Details</p>
                <b-row align-h="center">
                    <b-col>
                        <b-table show-empty head-variant="dark"
                                    stacked="md"
                                    bordered
                                    striped
                                    :items="familyMembers"
                                    :fields="fields"
                                    :current-page="currentPage"
                                    :per-page="perPage"
                                    :filter="filter"
                                    :sort-by.sync="sortBy"
                                    :sort-desc.sync="sortDesc"
                                    :sortDirection= "sortDirection"
                                    style="font-size:12px"   
                        >
                            <template slot="Gender" slot-scope="row">{{row.value?'Male':'Female'}}</template>
                            <template slot="show_details" slot-scope="row">
                            <!-- we use @click.stop here to prevent emitting of a 'row-clicked' event  -->
                            <b-button size="sm" @click.stop="row.toggleDetails" variant="link" class="m-0">
                            {{ row.detailsShowing ? 'Hide' : 'Show'}} Details
                            </b-button>
                            </template>
                            <template slot="actions" slot-scope="row">
                                <b-button size="sm" @click.stop="editMember(row.item, row.index, $event.target)" 
                                    class="mr-1 pt-0 pb-0" variant="outline-success" v-b-tooltip.hover title="Edit Member"  v-if="!LockProfile">
                                    <i class="fa fa-edit" style="font-size:16px;color:blue"></i> 
                                </b-button>
                                <b-button size="sm" @click.stop="deleteMember(row.item, row.index, $event.target)" 
                                    class="mr-1 pt-0 pb-0" variant="outline-danger" v-b-tooltip.hover title="Delete Member"  v-if="!LockProfile">
                                    <i class="fa fa-trash" style="font-size:16px;color:red"></i>
                                </b-button>
                            </template>
                            <template slot="row-details" slot-scope="row">
                                <b-card>
                                    <span>{{row.item.description}}</span>
                                </b-card>
                            </template>
                            </b-table>
                    </b-col>
                </b-row>
            </div>
            <b-modal id="modalConfirm" title="Are you sure?" size="sm">
              <pre>{{ modalInfo }}</pre>
              <div slot="modal-footer">
                  <b-button variant="danger" @click="modalConfirm" style= "margin-left:5px">Delete</b-button>
                  <b-button variant="info" @click="modalCancel" style= "margin-left:5px">Cancel</b-button>
              </div>
            </b-modal>
    </b-container>
</template>

<script>
import apis from "@/apis";
import Spinner from "vue-simple-spinner";
import DatePicker from 'vue2-datepicker';
var _currentDate = new Date();

const months = [
  "JAN",
  "FEB",
  "MAR",
  "APR",
  "MAY",
  "JUN",
  "JUL",
  "AUG",
  "SEP",
  "OCT",
  "NOV",
  "DEC"
];


export default {
  name: "FamilyDetails",
  components: { Spinner, DatePicker },
  data() {
    return {
      currentDate:_currentDate,
      relations: [
        { RelationshipID: 1, RelationshipName: "Father" },
        { RelationshipID: 2, RelationshipName: "Mother" },
        { RelationshipID: 3, RelationshipName: "Spouse" },
        { RelationshipID: 5, RelationshipName: "Son" },
        { RelationshipID: 4, RelationshipName: "Daughter" },
        { RelationshipID: 6, RelationshipName: "Brother" },
        { RelationshipID: 7, RelationshipName: "Sister" }
      ],
      // Md Tofiq (B) 28-2-19
      DOB:null, 
      // Md(E)
      form: {
        UserFamily: {
          FullName: "",
          Gender: 1,
          DOB: null,
          ReletionShipID: "",
          FamilyID: "00000000-0000-0000-0000-000000000000",
          UserID: ""
        },
        LoginID: ""
      },
      familyMembers: [],
      fields: [
        { key: "FullName", label: "Family Member Name", sortable: true },
        { key: "Gender", label: "Gender", sortable: true },
        { key: "DOB", label: "Birth Date",formatter: "convertDateFormat",sortable: true },
        { key: "ReletionshipName", label: "Relation", sortable: true },
        { key: "actions", label: "Edit" }
      ],
      showDismissibleAlert: false,
      variant: "success",
      alertText: "",
      isLoading: false,
      show: true,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      pageOptions: [5, 10, 15, 20, 50],
      sortBy: null,
      sortDesc: false,
      sortDirection:'asc',
      filter: null,
      modalInfo: "",
      selectedNomineeId: "",
      saved: false
    };
  },
  computed: {
    LockProfile() {
      let userinfo = this.$store.getters.getUserData;
      if (userinfo) {
        return userinfo.LockProfile;
      } else {
        return false;
      }
    }
  },
  methods: {
    format(value, event) {
      if (value) {
        return value.trim();
      }
    },

  convertDateFormat(inDate) {
      //return indate.split("T")[0];
      let dbDateTime = new Date(inDate);
      if(dbDateTime.getFullYear()==1){
        return null;
      }

      let formattedDate =
        dbDateTime.getDate() +
        "-" +
        months[dbDateTime.getMonth()] +
        "-" +
        dbDateTime.getFullYear();
      return formattedDate;
    },

    // Md Tofiq (B) 28-2-19
    convertDateFormatYMD(inDate){
      let dbDateTime = new Date(inDate);
      let formattedDate = dbDateTime.getFullYear() + "-" + (dbDateTime.getMonth()+1) + "-" + dbDateTime.getDate();
      return formattedDate;
    },
    // Md(E)

    onClickButton() {
      this.saved = false;
      this.showDismissibleAlert = false;
      this.$emit("clicked");
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.isLoading = true;
      var userinfo = this.$store.getters.loggedUser;
      this.form.LoginID = userinfo.UserId;
      this.form.UserFamily.UserID = userinfo.UserId;
      //this.form.UserFamily.FamilyID = '00000000-0000-0000-0000-000000000000';
      // Md Tofiq (B) 28-2-19
      this.form.UserFamily.DOB = this.convertDateFormatYMD(this.DOB);
      // Md(E)
      if (this.form.UserFamily.Gender == "1" || this.form.UserFamily.Gender == 1) {
         this.form.UserFamily.Gender = true;
       }
       else{
         this.form.UserFamily.Gender = false;
       }
       //alert(this.form.UserFamily.FamilyID);
          
      //let promise = apis.saveFamilyMember(this.form);
      
      let promise = apis.saveFamilyMember(this.form.UserFamily);

      promise
        .then(response => {
          //console.log(response);
          if (response.status == 200) {
            this.alertText = "Data Saved Successfully";
            this.getFamilyMembers();
            this.onReset();
            this.saved = true;
            this.variant = "success";
            this.showDismissibleAlert = true;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },
    onReset() {
      this.form.UserFamily.FamilyID = "00000000-0000-0000-0000-000000000000";
      this.form.UserFamily.FullName = "";
      this.form.UserFamily.Gender = 1;
      this.form.UserFamily.DOB = null;
      this.form.UserFamily.ReletionShipID = "";
      this.DOB = null;
    },
    editMember(item, index, target) {
      this.form.UserFamily.FamilyID = item.FamilyID;
      this.form.UserFamily.FullName = item.FullName;
      this.form.UserFamily.Gender = item.Gender ? 1 : 0;
      this.form.UserFamily.DOB = item.DOB.split("T")[0];
      this.form.UserFamily.ReletionShipID = item.ReletionShipID;
      // Md Tofiq (B) 28-2-19
      this.DOB = item.DOB;
      // Md(E)
    },
    getFamilyMembers() {
      var userinfo = this.$store.getters.loggedUser;
      let promise = apis.ReadFamilyMembers(userinfo.UserId);

      promise
        .then(response => {
          //console.log('Nominee Reponse' ,response);
          if (response.status == 200) {
            this.familyMembers = response.body;
            this.isLoading = false;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },
    //Delte Family Member post confirmation

    deleteMember(item, index, button) {
      var userinfo = this.$store.getters.loggedUser;
      this.form.UserFamily.FamilyID = item.FamilyID;
      this.form.UserFamily.FullName = item.FullName;
      this.form.UserFamily.Gender = item.Gender ? 1 : 0;
      this.form.UserFamily.DOB = item.DOB.split("T")[0];
      this.form.UserFamily.ReletionShipID = item.ReletionShipID;
      this.form.UserFamily.UserID = userinfo.UserId;

      let info = "You want to delete record for:" + "\n" + item.FullName;
      this.modalInfo = info;
      this.$root.$emit("bv::show::modal", "modalConfirm");
    },
    modalCancel() {
      this.onReset();
      this.$root.$emit("bv::hide::modal", "modalConfirm");
    },

    modalConfirm() {
      //let promise = apis.deleteFamilyMember(this.form);
      let promise = apis.deleteFamilyMember(this.form.UserFamily);

      promise
        .then(response => {
          if (response.status == 200) {
            this.alertText = "Record removed Successfully.";
            this.onReset();
            this.getFamilyMembers();
            this.showDismissibleAlert = true;
            this.variant = "success";
            this.isLoading = false;
          } else {
            this.alertText = response.body;
            this.showDismissibleAlert = true;
            this.variant = "warning";
          }
        })
        .catch(err => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
      this.$root.$emit("bv::hide::modal", "modalConfirm");
    }
  },
  mounted() {
    this.getFamilyMembers();
    let promise = apis.ReadRelations();

    promise
      .then(response => {
        //console.log('Nominee Reponse' ,response);
        if (response.status == 200) {
          this.relations = response.body;
          this.isLoading = false;
        } else {
          this.alertText = response.body;

          this.variant = "warning";
          this.showDismissibleAlert = true;
        }
      })
      .catch(err => {
        this.alertText = err.body;
        this.showDismissibleAlert = true;
        this.variant = "danger";
      });
  }
};
</script>

<style scoped>
.form-group {
  margin-bottom: 0.75rem;
}
</style>



// WEBPACK FOOTER //
// src/components/RegistrationDetails/Family.vue